import { useGetCrmPracticeQuery } from '@orthly/graphql-react';
import { useSession } from '@orthly/session-client';
import constate from 'constate';

export const [CrmPracticeProvider, useCrmPractice] = constate(() => {
    const session = useSession();
    return useGetCrmPracticeQuery({ variables: { practice_id: session?.organization_id ?? '' }, skip: !session });
});
